import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { HideScrollbar } from '../../../global/commonStyle';

const ModalBox = styled.div`
  height: 644px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  ${mobile_xl(css`
    height: 448px;
  `)}
`;

const GifItem = styled.div`
  padding: var(--space-8);
  column-count: 3;
  column-gap: var(--space-8);
  ${HideScrollbar}
  .gif-container {
    position: relative;
    width: 100%;
    max-width: 218px;
    height: max-content;
    cursor: pointer;
    display: flex;
    margin-bottom: var(--space-8);
    img {
      width: 100%;
      height: auto;
    }
    &:hover::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--card-background-hover);
    }
  }
  ${mobile_xl(css`
    column-count: 2;
  `)}
`;
export { ModalBox, GifItem };
